import { Flex } from '@applyboard/crystal-ui';

import { PageHeader } from '../../../components/PageHeader';
import { ApplicationExportTable, ApplicationExportPagination } from '../components';

export function TabletLayout() {
  return (
    <Flex p={6} gap={6} direction="column">
      <PageHeader title="Data Export" />
      <ApplicationExportTable />
      <ApplicationExportPagination />
    </Flex>
  );
}
